import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { Logo } from '../../../components/TrustElements/components/Logo.js';
import { Text } from '../../../components/TrustElements/components/Text.js';
import { TrustElementContainer } from '../../../components/TrustElements/components/TrustElementContainer.js';
import { Link, ParagraphMedium } from '../../../primitives/index.js';
import { SPACING_SMALL } from '../../../utils/spacingLegacy.js';
export const TrustElement = ({
  image,
  keyfact,
  link
}) => {
  const lgUp = useBreakpointUp('lg');
  // On smaller screen, we only display the image,
  // so if there is no image, we don't display anything for smaller screens
  const shouldBeDisplayed = image || lgUp;
  return shouldBeDisplayed && _jsxs(TrustElementContainer, {
    direction: "row",
    spacing: SPACING_SMALL,
    alignItems: "center",
    justifyContent: "flex-start",
    children: [image && _jsx("a", {
      href: link?.url,
      target: "_blank",
      rel: "noreferrer",
      children: _jsx(Logo, {
        alt: "",
        src: image
      })
    }), lgUp && _jsxs(ParagraphMedium, {
      children: [_jsx(Text, {
        content: keyfact
      }), link && _jsx(Link, {
        color: "contentPrimary",
        href: link.url,
        target: "_blank",
        rel: "noreferrer",
        children: link.title
      })]
    })]
  });
};